import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import EmailIcon from '@mui/icons-material/Email';
import InstagramIcon from '@mui/icons-material/Instagram';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import {
  Box,
  Grid,
  Typography,
  List,
  ListItem,
  ListItemIcon,
  Link,
} from '@mui/material';

import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

import { LEGAL_FOOTER_LINKS } from 'AppRoutes/LegalDocument';
import LogoPreto from 'assets/icons/logo_transparente_preto.png';

import styles, { logoStyle, paymentIconStyle } from './styles';
import { MercadoPagoLogo } from 'assets/icons';

const Footer = () => {
  const secureItems = [
    'Site seguro com criptografia (SSL).',
    'Blindado contra roubo e clonagem do cartão.',
    'Troca garantida em caso de extravio.',
  ];

  return (
    <Box sx={styles.footer}>
      <Grid container spacing={3} justifyContent="center">
        {/* Logo */}
        <Grid item xs={12} md={2.4}>
          <Box sx={styles.logoContainer}>
            <img
              src={LogoPreto}
              alt="Logo Clube da 42"
              style={logoStyle} // Usando um objeto CSSProperties aqui
            />
            <Typography variant="subtitle2">© 2026 Avenida 42</Typography>
          </Box>
        </Grid>

        {/* Contato */}
        <Grid item xs={12} md={2.4}>
          <Box sx={styles.centerContainer}>
            <Typography variant="h6" sx={styles.sectionTitle}>
              Contato
            </Typography>
            <Box sx={styles.contactContainer}>
              <Box sx={styles.contactItem}>
                <WhatsAppIcon sx={{ ...styles.icon, color: 'black' }} />
                <Typography variant="body2">+55 16 99769-7037</Typography>
              </Box>
              <Box sx={styles.contactItem}>
                <EmailIcon sx={{ ...styles.icon, color: 'black' }} />
                <Typography variant="body2">
                  contato@clubeda42.com.br
                </Typography>
              </Box>
            </Box>
          </Box>
        </Grid>

        {/* Mídias Sociais */}
        <Grid item xs={12} md={2.4}>
          <Box sx={styles.centerContainer}>
            <Typography variant="h6" sx={styles.sectionTitle}>
              Mídias Sociais
            </Typography>
            <Box sx={styles.socialIconsContainer}>
              <Link
                href="https://instagram.com/cervejaavenida42"
                target="_blank"
                rel="noopener noreferrer"
                sx={{ display: 'inline-flex', alignItems: 'center' }}
              >
                <InstagramIcon sx={{ ...styles.icon, color: 'black' }} />
              </Link>
            </Box>
          </Box>
        </Grid>

        {/* Formas de Pagamento */}
        <Grid item xs={12} md={2.4}>
          <Box sx={styles.centerContainer}>
            <Typography variant="h6" sx={styles.sectionTitle}>
              Formas de Pagamento
            </Typography>
            <Box sx={styles.paymentContainer}>
              <Box sx={styles.paymentGrid}>
                <img src={MercadoPagoLogo} style={paymentIconStyle} />
              </Box>
            </Box>
          </Box>
        </Grid>

        {/* Compra Segura */}
        <Grid item xs={12} md={2.4}>
          <Box sx={styles.centerContainer}>
            <Typography variant="h6" sx={styles.sectionTitle}>
              Compra Segura
            </Typography>
            <List>
              {secureItems.map((item, index) => (
                // eslint-disable-next-line react/no-array-index-key
                <ListItem key={index} disableGutters sx={styles.secureItem}>
                  <ListItemIcon sx={{ ...styles.checkIcon, color: 'black' }}>
                    <CheckCircleIcon />
                  </ListItemIcon>
                  <Typography variant="body2">{item}</Typography>
                </ListItem>
              ))}
            </List>
          </Box>
        </Grid>
      </Grid>
      <Box sx={styles.legalLinks}>
        {LEGAL_FOOTER_LINKS.map((item, index) => (
          <React.Fragment key={item.slug}>
            {index > 0 && (
              <Typography component="span" sx={styles.legalSeparator}>
                ·
              </Typography>
            )}
            <Link
              component={RouterLink}
              to={`/${item.slug}`}
              underline="hover"
              sx={styles.legalLink}
            >
              {item.label}
            </Link>
          </React.Fragment>
        ))}
      </Box>
      <Box sx={styles.developedByContainer}>
        <Typography variant="body2">Powered by</Typography>
        <Link
          href="https://tribefy.com.br"
          target="_blank"
          rel="noopener noreferrer"
          underline="none"
          sx={styles.tribefyLink}
        >
          <Box sx={styles.tribefyLogoMark}>
            <Typography variant="subtitle2" sx={styles.tribefyLogoLetter}>
              T
            </Typography>
          </Box>
          <Typography variant="subtitle2" sx={styles.tribefyText}>
            Tribefy
          </Typography>
        </Link>
      </Box>
    </Box>
  );
};

export default Footer;
